module.exports = __webpack_public_path__ + "envelope-solid.svg?6d2e611a5367de08d98dc4099f947fa4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/envelope-solid.svg
// module id = 179
// module chunks = 0